export const paginate = (theInput) => {
    //Do something with the input
    return theInput;
 };